import React from "react";
import styled from "styled-components";
import SvgFile from "./svg";

const Svg = styled(SvgFile)`
  @media (max-width: 520px) {
    width: 300px;
  }
`;

export const NotFound: React.FC = (props) => {
  return (
    <Svg
      width="511"
      height="218"
      viewBox="0 0 511 218"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M88.0746 217.2V172.5H0.474609V136.8L100.975 7.79999H128.275V136.5H154.675V172.5H128.275V217.2H88.0746ZM40.6746 136.5H92.5746V68.7L40.6746 136.5Z"
        fill="#D1D1D1"
      />
      <path
        d="M335.361 91.2C335.361 108.8 331.961 124.5 325.161 138.3C318.561 151.9 309.361 162.6 297.561 170.4C285.961 178.2 272.761 182.1 257.961 182.1C243.161 182.1 229.861 178.2 218.061 170.4C206.461 162.6 197.261 151.9 190.461 138.3C183.861 124.5 180.561 108.8 180.561 91.2C180.561 73.6 183.861 58 190.461 44.4C197.261 30.6 206.461 19.8 218.061 12C229.861 4 243.161 0 257.961 0C272.761 0 285.961 4 297.561 12C309.361 19.8 318.561 30.6 325.161 44.4C331.961 58 335.361 73.6 335.361 91.2ZM294.861 91.2C294.861 75.2 291.361 62.2 284.361 52.2C277.561 42 268.761 36.9 257.961 36.9C246.761 36.9 237.761 42 230.961 52.2C224.161 62.2 220.761 75.2 220.761 91.2C220.761 107.2 224.161 120.2 230.961 130.2C237.761 140.2 246.761 145.2 257.961 145.2C268.761 145.2 277.561 140.2 284.361 130.2C291.361 120.2 294.861 107.2 294.861 91.2Z"
        fill="#D1D1D1"
      />
      <path
        d="M443.739 217.2V172.5H356.139V136.8L456.639 7.79999H483.939V136.5H510.339V172.5H483.939V217.2H443.739ZM396.339 136.5H448.239V68.7L396.339 136.5Z"
        fill="#D1D1D1"
      />
    </Svg>
  );
};
